<template>
  <div>
    <!--    <span>WS服务地址:{{ wsUrl }}</span>-->
    <!--    <span>CMD:{{ cmd }}</span>-->
  </div>
</template>

<script>

import {websocketConfig} from "@/api/common";

export default {
  name: 'WsTag',
  props: {
    // --- webSocket 服务 -----
    cmd: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {
      wsUrl: null,
      WebSocket: null,
      timeout: 15 * 1000, // 心跳检测间隔 ms
      severTimeout: 3 * 1000, // 服务器超时时间，也就是websocket关闭重启时间 ms
      reconnectTimeout: 3 * 1000, // websocket重连时间间隔 ms
      timeoutObj: null,
      serverTimeoutObj: null,
      lockReconnect: false, // 连接状态标识
    }
  },
  watch: {},
  async mounted() {
    await this.getWebsocketConfig()
    if (!this.WebSocket)
      await this.initWebSocket()
  },
  beforeDestroy() {
    this.wsUrl = null
    this.WebSocket = null
    this.lockReconnect = true
    this.wsClose()
  },
  methods: {
    //获取当前用户的websocket请求地址【已登录】
    async getWebsocketConfig() {
      if (!this.wsUrl) {
        let {info} = await websocketConfig().then((res) => {
          return res.model
        })
        this.wsUrl = info.host || null
        // this.config.host = info.host || ''
      }
    },
    /* =============================================
      =            WebSocket 推送                   =
      =============================================*/
    // websocket初始化
    initWebSocket() {
      // console.log('initWebSocket')
      // console.log('init-ws')
      if (this.wsUrl) {
        // this.$notify.warning('即时通讯服务初始化中...')
        try {
          this.createWebSocket()
        } catch (e) {
          this.reconnect()
        }
      } else {
        this.$notify.warning('即时通讯服务初始化失败，未获取服务地址！！！')
      }

    },
    // websocket实例
    createWebSocket() {
      // console.log('createWebSocket')
      // const account = 'TS_USER_ID_' + userId
      // websocket地址
      // const url = `${config.WS_HOST}message?account=${account}`

      // const url = ''
      this.WebSocket = new WebSocket(this.wsUrl)
      //
      this.WebSocket.onopen = res => {
        this.reset()
        this.wsOnOpen(res)
        // this.$notify.success('即时通讯服务正常开启')
      }
      this.WebSocket.onmessage = e => {
        this.reset()
        this.wsOnMessage(e)
      }
      this.WebSocket.onerror = err => {
        this.reconnect()
        this.wsOnError(err)
      }
      this.WebSocket.onclose = res => {
        // this.$notify.warning('即时通讯服务异常关闭，重连中...')
        this.reconnect()
        this.wsOnClose(res)

      }
    },

    /* 事件 */
    // eslint-disable-next-line
    wsOnOpen(res) {
      // window.console.log('ws推送连接成功！')
      // 告诉服务端， 本次ws连接建立用于哪个场景
      this.wsSend({cmd: this.cmd})
    },
    wsOnMessage(e) {
      // window.console.log('消息:', e)
      const str = e.data
      if (typeof str === 'string') {
        try {
          const obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            if (obj.cmd && ['heart', 'onOpen'].indexOf(obj.cmd) === -1) {
              // 把消息推给父组件的方法-wsOnMessage
              this.$emit('wsOnMessage', obj)
              // this.$notify.info(obj.cmd)
            }
            return true
          } else {
            return false
          }
        } catch (e) {
          // console.log('error：' + str + '!!!' + e)
          return false
        }
      }
    },
    // eslint-disable-next-line
    wsOnClose(res) {
      // window.console.log('ws推送已关闭！')
    },
    wsOnError(res) {
      window.console.log('ws异常', res)
    },
    /* 方法 */
    wsSend(text) {
      text = JSON.stringify(text)
      if (this.WebSocket)
        this.WebSocket.send(text)
    },
    wsClose() {
      if (this.WebSocket) {
        this.WebSocket.close()
      }
    },

    /* 心跳检测 */
    start() {
      this.timeoutObj = setTimeout(() => {
        // send内容不可更改！！！发送内容与后端商定
        this.wsSend({cmd: 'heart'})
        this.serverTimeoutObj = setTimeout(() => {
          this.wsClose()
        }, this.severTimeout)
      }, this.timeout)
    },
    reset() {
      this.timeoutObj && clearTimeout(this.timeoutObj)
      this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj)
      this.start()
    },

    /* 计数，避免websocket重复连接 */
    reconnect() {
      if (this.lockReconnect) {
        return
      }
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      // tt && clearTimeout(tt);
      setTimeout(() => {
        this.initWebSocket()
        this.lockReconnect = false
      }, this.reconnectTimeout)
    }

    /* =====  End of WebSocket 推送  ======*/
  }
}
</script>

<style scoped>

</style>
